import React, { useState, useEffect, useRef } from 'react';
import JobsList from './jobs-list';
import JobSubmissionForm from './job-submission-form';
import { Event, EventTarget, EventType } from '../../utils/events';
import { useTranslation } from 'react-i18next';
import ToolButton, { ToolButtonType } from '../../tools/tool-button';
import './compute-jobs.css';
import { handleEvent } from '../../app-actions';
import { useAppDispatch } from '../../app/hooks';

/**
 * Compute Jobs Component
 */
const ComputeJobs: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const [showSubmissionForm, setShowSubmissionForm] = useState<boolean>(false);
  const [successMessage, setSuccessMessage] = useState<string | null>(null);
  const [sListKey, setListKey] = useState<number>(0);
  const refEventToJobsList = useRef<any>();

  const handleSubmitJob = () => {
    setShowSubmissionForm(true);
  };

  const handleFormClose = () => {
    setShowSubmissionForm(false);
  };

  const handleJobSubmitted = (jobId: string) => {
    setShowSubmissionForm(false);
    setSuccessMessage(`Job ${jobId} submitted successfully!`);

    // Clear success message after 5 seconds
    setTimeout(() => {
      setSuccessMessage(null);
    }, 5000);

    // Trigger refresh of jobs list
    if (refEventToJobsList.current) {
      refEventToJobsList.current({
        event: {
          eventTarget: EventTarget.COMPUTE_JOBS,
          eventType: EventType.COMPUTE_JOB_ADDED,
        },
      });
    }
  };

  //	------------------------------------------------------------
  //
  //	Set the event handler when the page starts up
  //
  //	------------------------------------------------------------

  useEffect(() => {
    console.log('[] hook fires [compute-jobs]');
    const newEvent: Event = {
      eventTarget: EventTarget.GLOBAL,
      eventType: EventType.GET_COMPUTE_JOBS,
    };
    dispatch(handleEvent({ event: newEvent }));
  }, [dispatch]);

  return (
    <div
      className="panel-main"
      style={{
        flex: '1 1 265px',
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        maxHeight: '100%',
      }}
    >
      <div style={{ flex: '0 0 5px' }} />
      <div
        style={{
          width: '100%',
          height: 'auto',
          display: 'flex',
          flexDirection: 'row',
          gap: '10px',
        }}
      >
        <div style={{ flex: '1 1' }} />
        <ToolButton
          name="refresh-button"
          type={ToolButtonType.SECONDARY}
          onClick={() => setListKey(sListKey + 1)}
          tooltip="Refresh"
          text="Refresh"
        />
        <ToolButton
          name="submit-job"
          text={t('Submit Job')}
          onClick={handleSubmitJob}
          type={ToolButtonType.PRIMARY}
        />
        <div style={{ flex: '0 0 5px' }} />
      </div>

      {successMessage && (
        <div className="success-message">
          <span>{successMessage}</span>
        </div>
      )}

      <div style={{ margin: '5px 5px 5px 5px' }}>
        <JobsList
          key={sListKey}
          setEventHandler={(handler: any) => (refEventToJobsList.current = handler)}
        />
      </div>

      <JobSubmissionForm
        show={showSubmissionForm}
        onClose={handleFormClose}
        onSuccess={handleJobSubmitted}
      />
    </div>
  );
};

export default ComputeJobs;
